<template>
  <div>
    <!-- <pre>
     projects: {{ projects }}
    </pre> -->
    <div class="md:flex md:mx-10 mb-10">
      <div class="md:w-2/3">
        <v-card class="md:mr-4 p-4" color="#F2F8FE">
          <div class="font-bold">COMPANY</div>
          <div class="md:flex w-full">
            <div class="border-2 py-1 border-gray-300 mr-2 w-1/3">
              <v-text-field
                v-model="company"
                :error-messages="companyErrors"
                :counter="30"
                label="Name of Company"
                required
                class="bg-white px-4 py-2 w-full"
                @input="$v.company.$touch()"
                @blur="$v.company.$touch()"
              ></v-text-field>
            </div>
            <div class="border-2 py-1 border-gray-300 mr-2 w-1/3">
              <v-text-field
                class="bg-white px-4 py-2 w-full"
                v-model="certificate_of_registration"
                placeholder="Certificate of Registration No."
                label="Certificate of Registration No."
                :error-messages="certErrors"
                required
                @input="$v.certificate_of_registration.$touch()"
                @blur="$v.certificate_of_registration.$touch()"
              ></v-text-field>
            </div>
            <!-- <div class="border-2 py-1 border-gray-300 mr-2 w-1/3">
              <v-text-field
                class="bg-white px-4 py-2 w-full"
                v-model="certificate_of_registration"
                placeholder="Company Tax Identification No."
                label="Company Tax Identification No."
              ></v-text-field>
            </div> -->
          </div>
        </v-card>
        <v-card class="md:mr-4 px-4" color="#F2F8FE">
          <div class="font-bold">
            AUTHORIZED SIGNATORY IN SECRETARY CERTIFICATE
          </div>
          <div class="md:flex">
            <div class="border-2 border-gray-300 mr-2">
              <v-text-field
                class="bg-white px-4 py-2 w-full"
                v-model="sec_firstname"
                placeholder="First Name"
                label="First Name"
                :error-messages="sec_firstname_errors"
                required
                @input="$v.sec_firstname.$touch()"
                @blur="$v.sec_firstname.$touch()"
                :counter="20"
              ></v-text-field>
            </div>
            <div class="border-2 border-gray-300 mr-2">
              <v-text-field
                class="bg-white px-4 py-2 w-full"
                v-model="sec_middlename"
                placeholder="Middle Name"
                label="Middle Name"
                :error-messages="sec_middlename_errors"
                required
                @input="$v.sec_middlename.$touch()"
                @blur="$v.sec_middlename.$touch()"
                :counter="20"
              ></v-text-field>
            </div>
            <div class="border-2 border-gray-300 mr-2">
              <v-text-field
                class="bg-white px-4 py-2 w-full"
                v-model="sec_lastname"
                placeholder="Last Name"
                label="Last Name"
                :error-messages="sec_lastname_errors"
                required
                @input="$v.sec_lastname.$touch()"
                @blur="$v.sec_lastname.$touch()"
                :counter="20"
              ></v-text-field>
            </div>

            <div class="border-2 border-gray-300 mr-2">
              <input
                placeholder="Suffix"
                type="text"
                class="bg-white px-4 py-1 w-full"
                v-model="sec_suffix"
              />
            </div>
          </div>
        </v-card>
        <v-card class="md:mr-4 px-4 py-2" color="#F2F8FE">
          <div class="font-bold">NEW CONTACT INFORMATION TO REGISTER</div>
          <div class="md:flex">
            <div class="border-2 border-gray-300 mr-2">
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                class="bg-white px-4 py-1 w-full"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
            </div>
            <div class="border-2 border-gray-300 mr-2">
              <v-text-field
                v-model="mobile"
                :error-messages="mobileErrors"
                :counter="11"
                label="Mobile Number"
                required
                class="bg-white px-4 pt-2 w-full"
                @input="$v.mobile.$touch()"
                @blur="$v.mobile.$touch()"
              ></v-text-field>
            </div>
          </div>
        </v-card>
        <v-card class="md:mr-4 px-4 my-2 py-2" color="#F2F8FE">
          <div class="font-bold">MOLDEX PROPERTY INFORMATION</div>
          <div>
            <div class="w-full my-2 border-2 mr-2 border-gray-300">
              <v-select
                class="w-full px-4 bg-white"
                label="Project"
                :items="items"
                item-value="project"
                item-text="project"
                v-model="project"
                autocomplete
              ></v-select>
            </div>
            <div class="sm:flex w-full">
              <div class="w-1/3 border-2 mr-2 border-gray-300">
                <input
                  required
                  class="w-full py-2 px-4 bg-white"
                  type="text"
                  placeholder="Phase"
                  v-model="phase"
                />
              </div>
              <div class="w-1/3 border-2 mr-2 border-gray-300">
                <input
                  required
                  class="w-full py-2 px-4 bg-white"
                  type="text"
                  placeholder="Block"
                  v-model="block"
                />
              </div>
              <div class="w-1/3 border-2 border-gray-300">
                <input
                  required
                  class="w-full py-2 px-4 bg-white"
                  type="text"
                  placeholder="Lot"
                  v-model="lot"
                />
              </div>
            </div>
            <!-- Floor & Unit No. -->
            <div class="sm:flex w-full my-2">
              <div class="w-1/2 border-2 border-gray-300 mr-2">
                <input
                  class="w-full py-2 px-4 bg-white"
                  type="text"
                  placeholder="Building"
                  v-model="building"
                />
              </div>
              <div class="w-1/2 border-2 border-gray-300">
                <input
                  class="w-full mr-2 py-2 px-4 bg-white"
                  type="text"
                  placeholder="Floor/Unit No."
                  v-model="floor"
                />
              </div>
            </div>
            <div class="sm:flex w-full my-2">
              <div class="w-full border-2 border-gray-300">
                <v-text-field
                  v-model="contractnumber"
                  :error-messages="cnErrors"
                  :counter="13"
                  class="bg-white px-4 pt-2 w-full"
                  label="Contract Number"
                  required
                  @input="$v.contractnumber.$touch()"
                  @blur="$v.contractnumber.$touch()"
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="boxRight p-4 md:w-1/3">
        <div class="font-bold">
          {{ notes[0]["text"] }}
        </div>
        <input
          ref="file"
          type="file"
          style="display: none"
          @change="onUpload"
        />
        <div class="bg-white p-4">
          <div v-for="(item, i) in instructions" :key="i">
            <li>
              {{ item.text }}
            </li>
          </div>
        </div>
        <div class="my-4">
          <div class="py-2" v-for="(item, i) in attachments" :key="i">
            <div>
              {{ item.label }}
            </div>
            <v-btn
              @click="startUpload(item.id)"
              class="w-full justify-start"
            >
              <div class="flex justify-between items-center">
                <div>{{ item.file ? item.file.name : "Attach File" }}</div>
                <div>
                  <v-icon> mdi-attachment </v-icon>
                </div>
              </div>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-10 md:flex w-full">
      <v-btn class="py-6 w-1/2 md:mr-2" color="red" dark @click="cancel">
        Cancel
      </v-btn>
      <v-btn
        @click="on_submit_bis_form"
        class="py-6 w-1/2"
        color="#19196B"
        dark
      >
        Submit My Updated Buyer's Information Sheet
      </v-btn>
    </div>
    <v-dialog
      v-model="success_dialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="p-10 bg-white">
        <BisMessage />
        <v-btn class="w-full" small @click="bis_done"> Ok </v-btn>
      </div>
    </v-dialog>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { projects } from "./Projects.js";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import BisMessage from "./BisMessage.vue";
// import {project_list} from "../components/Projects.js";
export default {
  mixins: [validationMixin],
  validations: {
    sec_firstname: { required, maxLength: maxLength(20) },
    sec_middlename: { required, maxLength: maxLength(20) },
    sec_lastname: { required, maxLength: maxLength(20) },
    company: { required, maxLength: maxLength(30) },
    mobile: { required, maxLength: maxLength(10) },
    contractnumber: { required, maxLength: maxLength(13) },
    email: { required, email },
    select: { required },
    certificate_of_registration: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  components: { BisMessage },
  methods: {
    bis_done() {
      this.$router.push("/login");
    },
    startUpload(id) {
      this.$refs.file.click();
      this.currentAttachmentId = id;
    },
    onUpload(e) {
      const file = e.target.files[0];
      if (!file || this.currentAttachmentId === null) {
        return;
      }
      this.attachments.find((a) => a.id === this.currentAttachmentId).file =
        file;
    },
    on_submit_bis_form() {
      if (
        this.certificate_of_registration &&
        this.company &&
        this.mobile &&
        this.email &&
        this.sec_firstname &&
        this.sec_middlename &&
        this.sec_lastname &&
        this.contractnumber
      ) {
        const data = new FormData();

        data.append(
          "certificate_of_registration",
          this.certificate_of_registration
        );
        data.append("company", this.company);
        data.append("mobile", this.mobile);
        data.append("email", this.email);
        data.append("sec_firstname", this.sec_firstname);
        data.append("sec_middlename", this.sec_middlename);
        data.append("sec_lastname", this.sec_lastname);
        data.append("contractnumber", this.contractnumber);
        data.append("phase", this.phase);
        data.append("block", this.block);
        data.append("lot", this.lot);
        data.append("building", this.building);
        data.append("floor", this.floor);
        data.append("project", this.project);

        for (const attachment of this.attachments) {
          data.append(attachment.id.toString(), attachment.file);
        }
        axios
          .post("/bis/co/submit", data)
          .then((res) => {
            if (res.data.status) {
              this.success_dialog = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.snackbar = true;
        this.snackbarText = "Please complete the required fields.";
      }
    },
    cancel() {
      this.$router.push("/login");
    },
  },
  computed: {
    cnErrors() {
      const errors = [];
      if (!this.$v.contractnumber.$dirty) return errors;
      !this.$v.contractnumber.maxLength &&
        errors.push("Contract number must be at most 13 characters long");
      !this.$v.contractnumber.required &&
        errors.push("Contract number is required.");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      !this.$v.mobile.maxLength &&
        errors.push("Mobile number must be at most 11 characters long");
      !this.$v.mobile.required && errors.push("Mobile number is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    companyErrors() {
      const errors = [];
      if (!this.$v.company.$dirty) return errors;
      !this.$v.company.maxLength &&
        errors.push("Company name must be at most 30 characters long");
      !this.$v.company.required && errors.push("Company name is required.");
      return errors;
    },
    certErrors() {
      const errors = [];
      if (!this.$v.certificate_of_registration.$dirty) return errors;

      !this.$v.certificate_of_registration.required &&
        errors.push("Certificate of registration number is required.");
      return errors;
    },
    sec_firstname_errors() {
      const errors = [];
      if (!this.$v.sec_firstname.$dirty) return errors;

      !this.$v.sec_firstname.required && errors.push("First name is required.");
      return errors;
    },
    sec_middlename_errors() {
      const errors = [];
      if (!this.$v.sec_middlename.$dirty) return errors;

      !this.$v.sec_middlename.required &&
        errors.push("Middle name is required.");
      return errors;
    },
    sec_lastname_errors() {
      const errors = [];
      if (!this.$v.sec_lastname.$dirty) return errors;

      !this.$v.sec_lastname.required && errors.push("Last name is required.");
      return errors;
    },
    regErrors() {
      const errors = [];
      if (!this.$v.company.$dirty) return errors;
      !this.$v.company.maxLength &&
        errors.push("Company name must be at most 30 characters long");
      !this.$v.company.required && errors.push("Company name is required.");
      return errors;
    },
  },
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      success_dialog: false,
      currentAttachmentId: null,
      attachments: [
        {
          id: 1,
          label: "Upload ID 1",
          file: null,
        },
        {
          id: 2,
          label: "Upload ID 2",
          file: null,
        },
        {
          id: 3,
          label: "Upload Signatures",
          file: null,
        },
      ],
      sec_suffix: "",
      items: projects,
      contact_information: [],
      company_details: [],
      address_details: null,
      project: null,
      phase: "",
      block: "",
      lot: "",
      building: "",
      floor: "",
      // required
      certificate_of_registration: "",
      company: "",
      mobile: "",
      email: "",
      sec_firstname: "",
      sec_middlename: "",
      sec_lastname: "",
      contractnumber: "",

      notes: [
        {
          text: "Attach the following documents:",
        },
      ],
      instructions: [
        {
          text: "Submit a copy of your two (2) photo-bearing valid government issued IDs (of all Buyers)",
        },
        {
          text: "Submit a copy of your three (3) specimen signatures with the current date written (of all Buyers)",
        },
      ],
      dialog: false,
      dialogMessage:
        "I certify the information provided is true and correct. I understand that if my contact information shall change, it will be my responsibility to submit a new Buyers Information Sheet to Moldex Head Office for updating. I hereby bind myself that any notice, letter and/or correspondence sent to my contact numbers, or postal address shall be considered as validly served to me. I understand the postal address of the Principal Buyer mentioned will be the address indicated in the notices sent to me and indicated in my official documents such as the Contract To Sell, Deed of Absolute Sale, and other pertinent documents. I expressly waive my right under any confidentiality laws, including but not limited to R.A. No. 10173 (Data Privacy Act of 2012). Likewise, I hereby authorize Moldex and its employees to make use of all my personal data and they may divulge the same to their agents, sales personnel and others. I hereby hold Moldex Realty, Inc./Moldex Land, Inc. free and harmless from any liability that may arise from the collection, processing, storing, destruction and disclosure of any information regarding my purchased property/unit with Moldex.",
    };
  },
};
</script>

<style scoped>
.boxRight {
  background: #e9967a;
}
</style>